import React, { useEffect, useState } from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  SafeAreaView,
  TextInput,
  TouchableOpacity,
  ActivityIndicator,
} from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { formatDistanceToNow, parseISO } from 'date-fns';

const BrandActivityFeed = ({ navigation }) => {
  const [activity, setActivity] = useState([]);
  const [filteredActivity, setFilteredActivity] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    fetch('https://collabbayadmin.com/APIControllers/BrandActivity.php', {
      credentials: 'include',
    })
      .then((res) => res.json())
      .then((data) => {
        setActivity(data);
        setFilteredActivity(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Failed to fetch activity:', err);
        setLoading(false);
      });
  }, []);

  const handleSearch = (query) => {
    setSearchQuery(query);
    if (!query) {
      setFilteredActivity(activity);
    } else {
      const filtered = activity.filter((item) =>
        item.Promoter.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredActivity(filtered);
    }
  };
  

  const formatTime = (timestamp) => {
    try {
      return `Updated ${formatDistanceToNow(parseISO(timestamp), { addSuffix: true })}`;
    } catch {
      return `Updated ${timestamp}`;
    }
  };

  const getStatusLabel = (item) => {
    const today = new Date();
    const creditAvailableDate = new Date(item.CreditAvailableStart);

    if (creditAvailableDate < today) {
      if (item.Redeemed === '1') {
        return 'Redeemed';
      } else {
        return 'Expired';
      }
    } else {
      if (item.Status === 'Accepted') {
        return 'Upcoming';
      } else if (item.Status === 'Pending') {
        return 'Pending';
      }
    }
    return 'Other';
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case 'Upcoming':
        return { backgroundColor: '#d4f5d4', color: 'black' };
      case 'Redeemed':
        return { backgroundColor: '#228B22', color: 'white' };
      case 'Pending':
        return { backgroundColor: '#fff89a', color: 'black' };
      case 'Expired':
        return { backgroundColor: '#e0e0e0', color: 'black' };
      default:
        return { backgroundColor: '#ccc', color: 'black' };
    }
  };

  const renderIcon = (type) => {
    switch (type) {
      case 'New Request': return <Ionicons name="mail-unread-outline" size={20} color="black" />;
      case 'Message': return <Ionicons name="chatbox-ellipses-outline" size={20} color="black" />;
      case 'Date Changed': return <Ionicons name="calendar-outline" size={20} color="black" />;
      case 'Accepted': return <Ionicons name="checkmark-done-circle-outline" size={20} color="black" />;
      default: return <Ionicons name="notifications-outline" size={20} color="black" />;
    }
  };

  const renderCard = (item, index) => {
    const status = getStatusLabel(item);
    const statusStyle = getStatusStyle(status);

    const isSentByBrand = item.LastUpdateFrom === item.BrandName;
    const direction = isSentByBrand ? `To: ${item.Promoter}` : `From: ${item.Promoter}`;

    return (
      <TouchableOpacity
        key={index}
        style={styles.card}
        onPress={() => navigation.navigate('SingleCollabMetrics', { CollabID: item.CollabID, openChatModal: true })}
      >
        <View style={styles.cardHeader}>
          {renderIcon(item.ActivityType)}
          <View style={{ flex: 1, marginLeft: 10 }}>
            <Text style={styles.promoterText}>{item.Promoter}</Text>
            <Text style={styles.subjectText}>{item.ActivityType}</Text>
          </View>
          <Text style={styles.timeText}>{formatTime(item.Date)}</Text>
        </View>

        <Text style={styles.metaText}>{direction}</Text>

        <View style={styles.cardFooterRow}>
          <Text style={[styles.statusLabel, { backgroundColor: statusStyle.backgroundColor, color: statusStyle.color }]}> {status} </Text>
          <Ionicons name="chatbox-outline" size={22} color="black" style={{ marginLeft: 10 }} />
        </View>
      </TouchableOpacity>
    );
  };

  return (
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
    <SafeAreaView style={styles.wrapper}>
      <View style={styles.topBar}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Ionicons name="arrow-back" size={28} color="black" />
        </TouchableOpacity>
        <Text style={styles.pageTitle}>Activity Feed</Text>
      </View>

      <TextInput
        style={styles.searchInput}
        placeholder="Search activity..."
        value={searchQuery}
        onChangeText={handleSearch}
      />

      {loading ? (
        <ActivityIndicator size="large" color="black" style={{ marginTop: 20 }} />
      ) : (
        <ScrollView contentContainerStyle={{ paddingBottom: 80 }}>
          {filteredActivity.length === 0 ? (
            <Text style={styles.emptyText}>No activity found.</Text>
          ) : (
            filteredActivity.map((item, index) => renderCard(item, index))
          )}
        </ScrollView>
      )}



      <View style={styles.footer}>

  <TouchableOpacity
    style={styles.footerIcon}
    onPress={() => navigation.navigate('BrandActivityFeed')}
  >
    <Ionicons name="chatbox-ellipses-outline" size={24} color="black" />
  </TouchableOpacity>

          <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('BusinessAccountPage')}>
            <Ionicons name="person" size={24} color="black" />
          </TouchableOpacity>
    

        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('BusinessHomepage')}>
          <Ionicons name="home" size={24} color="black" />
        </TouchableOpacity>
        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('CollabCalendar')}>
          <Ionicons name="calendar" size={24} color="black" />
        </TouchableOpacity>
        <TouchableOpacity style={styles.footerIcon} onPress={() => navigation.navigate('CreateBrandListingChoice')}>
          <Ionicons name="add" size={24} color="black" />
        </TouchableOpacity>
      </View>
      
    </SafeAreaView>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    backgroundColor: '#fff',
    maxWidth: 600,
    alignSelf: 'center',
    width: '100%',
  },
  topBar: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
    paddingTop: 10,
    paddingBottom: 5,
  },
  pageTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    marginLeft: 10,
  },
  searchInput: {
    margin: 10,
    padding: 10,
    borderColor: '#ccc',
    borderWidth: 1,
    borderRadius: 20,
    backgroundColor: '#f3f3f3',
  },
  card: {
    backgroundColor: '#fff',
    padding: 15,
    marginHorizontal: 10,
    marginVertical: 6,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  cardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  promoterText: {
    fontWeight: 'bold',
    fontSize: 15,
  },
  timeText: {
    fontSize: 12,
    color: '#888',
    marginLeft: 5,
  },
  subjectText: {
    fontSize: 14,
    color: '#333',
    marginTop: 2,
  },
  metaText: {
    fontSize: 12,
    color: '#555',
    marginTop: 4,
  },
  statusLabel: {
    alignSelf: 'flex-start',
    paddingVertical: 3,
    paddingHorizontal: 10,
    borderRadius: 15,
    fontSize: 12,
    marginTop: 6,
  },
  cardFooterRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 6,
  },
  emptyText: {
    textAlign: 'center',
    color: '#555',
    marginTop: 30,
    fontSize: 16,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: '#fff',
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    paddingVertical: 10,
    borderColor: '#ddd',
  },
  footerIcon: {
    alignItems: 'center',
  },
});

export default BrandActivityFeed;
